<template>
 <span
  class="
   w-12
   h-12
   border-blue-600 border-4 border-b-transparent
   ease
   rounded-full
   absolute
   md:left-[48%]
   left-[45%]
   top-56
   block
   animate-spin
  "
 ></span>
</template>